module.exports = __webpack_public_path__ + "static/media/TP.fe293657.webp";